import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as MasterTemplateNotSavedChangesActions from './master-template-not-saved-changes.actions';
import * as MasterTemplateNotSavedChangesSelectors from './master-template-not-saved-changes.selectors';
import { first, forkJoin, Observable } from 'rxjs';
import { MasterTemplateResponseData } from '@cpak/adp-cpak-bff-service-models';
import { MasterTemplateNotSavedChangesEntity } from './master-template-not-saved-changes.reducer';

@Injectable()
export class MasterTemplateNotSavedChangesFacade {
  private readonly maximumNotSavedTemplates = 100;

  constructor(private readonly store: Store) {}

  public addMasterTemplateChangesToStore(
    templateId: string,
    templateData: Pick<MasterTemplateResponseData, 'categories'>
  ): void {
    forkJoin([
      this.store
        .pipe(select(MasterTemplateNotSavedChangesSelectors.getMasterTemplatesNotSavedChangesEntities()))
        .pipe(first()),
      this.store
        .pipe(select(MasterTemplateNotSavedChangesSelectors.getMasterTemplatesNotSavedChangesTotal()))
        .pipe(first()),
    ]).subscribe(([entities, total]) => {
      if (entities && !entities[templateId] && total >= this.maximumNotSavedTemplates) {
        const firstPackId = Object.keys(entities)[0];
        this.clearChangesForMasterTemplate(firstPackId);
      }
    });
    this.store.dispatch(
      MasterTemplateNotSavedChangesActions.updateNotSavedMasterTemplateChanges({
        templateId,
        templateData,
      })
    );
  }

  public clearAllChanges(): void {
    this.store.dispatch(MasterTemplateNotSavedChangesActions.removeNotSavedChangesForAllTemplates());
  }

  public clearChangesForMasterTemplate(templateId: string): void {
    this.store.dispatch(MasterTemplateNotSavedChangesActions.removeNotSavedChangesForMasterTemplate({ templateId }));
  }

  public getMasterTemplateChanges(templateId: string): Observable<MasterTemplateNotSavedChangesEntity | undefined> {
    return this.store.pipe(
      select(MasterTemplateNotSavedChangesSelectors.getNotSavedChangesForMasterTemplate(templateId))
    );
  }
}
